import style from './style';
import { useReducer } from "preact/hooks";

const Header = (props) => {

	const [burger, setBurger] = useReducer((state) => {
		return !state;
    }, false);

	const shareUrl = (() => {
		return `https://www.currenttime.tv/a/runet/30107847.html${props.site > 0 ? `%23episode=${props.site}` : ''}`;
	})();

    const wOverlay = () => { return props.overlayVisible ? style['header-w-overlay--'+props.site] : ''};
	return (
		<header class={`${style['header']} ${style[`header--${props.site}`]} ${wOverlay()}`}>
			<nav>
				<div class={style['header-links']}>
					<a class={`${style[`link--${props.site}`]} ${style['link']} ${style['link--logo']}`} href="https://currenttime.tv" target='_blank'>{props.site === 1 && '>'}Настоящее Время</a>
					<a class={`${style[`link--${props.site}`]} ${style['link']}`} onClick={(e) => props.setOverlay(e, 'o-projekte')}>
						{props.site === 1 && '>'}О проекте
					</a>
					<a class={`${style[`link--${props.site}`]} ${style['link']}`} onClick={(e) => props.setOverlay(e, 'ob-avtore')}>
						{props.site === 1 && '>'}Об авторе
					</a>
					<a class={`${style[`link--${props.site}`]} ${style['link']}`} onClick={(e) => props.setOverlay(e, 'o-gerojah')}>
						{props.site === 1 && '>'}О героях
					</a>
					<a class={`${style[`link--${props.site}`]} ${style['link']}`} onClick={(e) => props.setOverlay(e, 'episodes')}>
						{props.site === 1 && '>'}Эпизоды
					</a>
				</div>
				<div class={`${style['header__share']} ${style[`header__share--${props.site}`]}`}>
						Поделись:
					<a
						class={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--fb`]}`}
						href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
						target='_blank'
					>
						FB
					</a>
					<a
						class={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--vk`]}`}
						href={`http://vkontakte.ru/share.php?url=${shareUrl}`}
						target='_blank'
					>
						VK
					</a>
					<a
						class={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--twt`]}`}
						href={`https://twitter.com/share?url=${shareUrl}&amp;text=Холивар.%20История%20Рунета&amp;`}
						target='_blank'
					>
                        TWT
                    </a>
					<a
						class={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--tg`]}`}
						href={`https://telegram.me/share/url?url=${shareUrl}&text=Холивар.%20История%20Рунета`}
						target='_blank'
					>
						TG
					</a>
				</div>
				<div class={`${style['burger']} ${style[`burger--${props.site}`]}`} onClick={() => {
					setBurger();
					if (props.overlayVisible) {
						props.closeOverlay();
					}
				}}>
					МЕНЮ
				</div>
			</nav>
			{burger &&
				<div class={`${style['burger__menu']} ${style[`burger__menu--${props.site}`]}`}>

					<div onClick={(e) => {
						setBurger();
						props.setOverlay(e, 'o-projekte')
					}}>
						<a class={`${style[`link--${props.site}`]} ${style['link']}`}>О проекте</a>
					</div>
					<div onClick={(e) => {
						setBurger();
						props.setOverlay(e, 'ob-avtore')
					}}>
						<a class={`${style[`link--${props.site}`]} ${style['link']}`}>Об авторе</a>
					</div>
					<div onClick={(e) => {
						setBurger();
						props.setOverlay(e, 'o-gerojah')
					}}>
						<a class={`${style[`link--${props.site}`]} ${style['link']}`}>О героях</a>
					</div>
					<div onClick={(e) => {
						setBurger();
						props.setOverlay(e, 'episodes')
					}}>
						<a class={`${style[`link--${props.site}`]} ${style['link']}`}>Эпизоды</a>
					</div>
					<div>
						Поделись:
                        <a className={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--fb`]}`}
                           href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                           target='_blank'>
                            FB
                        </a>
                        <a className={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--vk`]}`}
                           href={`http://vkontakte.ru/share.php?url=${shareUrl}`}
                           target='_blank'>
                            VK
                        </a>
                        <a className={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--twt`]}`}
                           href={`https://twitter.com/share?url=${shareUrl}&amp;text=Холивар.%20История%20Рунета&amp;`}
                           target='_blank'>
                            TWT
                        </a>
                        <a className={`${style['social-icon']} ${style[`social-icon--${props.site}`]} ${style[`social-icon--tg`]}`}
                           href={`https://telegram.me/share/url?url=${shareUrl}&text=Холивар.%20История%20Рунета`}
                           target='_blank'>
                            TG
                        </a>
					</div>
				</div>
			}
		</header>
	)
}

export default Header;
